import React from "react";
import { Typography, makeStyles, Grid } from "@material-ui/core";

import { Icon } from "../base";
import { IconText } from "../base/Button";
import { COLORS } from "../../theme/colors";

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex"
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    color: COLORS.darks[0][100]
  },
  subTitle: {
    fontWeight: 400,
    fontSize: 14,
    color: COLORS.darks[0][50]
  },
  icon: {
    height: "48px"
  },
  textContainer: {
    paddingTop: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginLeft: 15
  }
}));

function SettingHeader({
  title,
  subtitle,
  img,
  buttonIcon,
  buttonText,
  mr,
  setOpen,
  style,
}) {
  const classes = useStyles();

  return (
    <Grid container direction="row" justifyContent="space-between" style={style}>
      <div className={classes.container}>
        <div>
          <Icon src={img} className={classes.icon} />
        </div>
        <div className={classes.textContainer}>
          <Typography variant="h4" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="body1" className={classes.subTitle}>
            {subtitle}
          </Typography>
        </div>
      </div>
      {(buttonText || buttonIcon) && (
        <div style={{ marginRight: mr }}>
          <IconText
            text={buttonText}
            prevIcon={buttonIcon}
            onClick={() => setOpen(true)}
          />
        </div>
      )}
    </Grid>
  );
}

export default SettingHeader;
